import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/shop/ShopLiquidParticles.tsx");
